module.exports = __webpack_public_path__ + "media/assets/images/landing/Group 2-dc0025b0694f4c47eec2e39d2145da01.png";